<template>
    <div>
        <b-card :header="uLang('app.question')" header-tag="h4" class="bg-default-card">
            <div v-if="faq !== null">
                <h3>{{ faq.question }}</h3>
                <hr>
                <div v-html="faq.answer"></div>

                <div class="mt-5">
                    <router-link class="btn btn-brand" :to="{ name: 'admin.faq.index' }" active-class="">
                        <i class="fa fa-arrow-left"></i>
                        {{ uLang('app.go_to_overview') }}
                    </router-link>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
    export default {
        name: 'show',

        props: {
            id: {
                required: true,
            },
        },

        data() {
            return {
                faq: null,
            }
        },

        created () {
            this.retrieveFaq();
        },

        methods: {
            async retrieveFaq() {
                const { data } = await window.axios.get(route('faq.show', {faq: this.id}));
               
                this.faq = data;
            }
        }
    }
</script>

<style lang="css" scoped>
</style>